import React from 'react'
import { Outlet } from 'react-router-dom'

import { MainContent } from '@campaignhub/suit-theme'
import useFreshDesk from '@hooks/useFreshDesk'
import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@suiteThemeCustom/TopBar/components/LoggedInUser'
import TimeTracker from '@suiteThemeCustom/TopBar/components/TimeTracker'
import TopBar from '@suiteThemeCustom/TopBar'
import Notifications from '@suiteThemeCustom/TopBar/components/Notifications'

import MainNavigation from '@sections/OnSite/components/MainNavigation'
import ServiceJobsSearch from '@components/ServiceJobsSearch'

const Dashboard = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  useFreshDesk()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        notificationComponent={<Notifications />}
        searchComponent={<ServiceJobsSearch />}
        timeTrackerComponent={<TimeTracker />}
      />

      <MainNavigation minimized />

      <MainContent offset={{ top: TopBar.topBarHeight, left: 70 }}>
        <Outlet />
      </MainContent>
    </>
  )
}

export default Dashboard
